import React from 'react';
import {
  FileText, FileImage, FileVideo, FileAudio, FileSpreadsheet, FileCode, File as FileIcon,
} from 'lucide-react';

/** MVP Sprint Item 3 — helpers for evidence filename row. */

const EXT_RE = /\.([a-z0-9]{2,6})$/i;

export function extractExtension(filename) {
  if (!filename) return null;
  const m = String(filename).match(EXT_RE);
  return m ? m[1].toLowerCase() : null;
}

export function formatFileSize(bytes) {
  if (bytes == null || bytes === 0) return null;
  const units = ['B', 'KB', 'MB', 'GB'];
  let v = Number(bytes);
  if (!isFinite(v) || v < 0) return null;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) { v /= 1024; i += 1; }
  const rounded = v >= 10 || i === 0 ? Math.round(v) : Math.round(v * 10) / 10;
  return `${rounded} ${units[i]}`;
}

const EXT_TO_ICON = {
  pdf: FileText,
  doc: FileText, docx: FileText, rtf: FileText, txt: FileText, md: FileText,
  xls: FileSpreadsheet, xlsx: FileSpreadsheet, csv: FileSpreadsheet,
  jpg: FileImage, jpeg: FileImage, png: FileImage, gif: FileImage, webp: FileImage, heic: FileImage,
  mp4: FileVideo, mov: FileVideo, webm: FileVideo, avi: FileVideo, mkv: FileVideo,
  mp3: FileAudio, wav: FileAudio, m4a: FileAudio, flac: FileAudio, ogg: FileAudio,
  json: FileCode, xml: FileCode, html: FileCode, js: FileCode, py: FileCode,
};

export function FileTypeIcon({ ext, className = 'h-4 w-4 text-slate-500' }) {
  const Cmp = (ext && EXT_TO_ICON[ext]) || FileIcon;
  return <Cmp className={className} aria-hidden="true" />;
}

const EXT_PALETTE = {
  pdf: 'bg-rose-50 text-rose-700 border-rose-200',
  doc: 'bg-blue-50 text-blue-700 border-blue-200', docx: 'bg-blue-50 text-blue-700 border-blue-200',
  xls: 'bg-emerald-50 text-emerald-700 border-emerald-200', xlsx: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  csv: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  jpg: 'bg-purple-50 text-purple-700 border-purple-200', jpeg: 'bg-purple-50 text-purple-700 border-purple-200',
  png: 'bg-purple-50 text-purple-700 border-purple-200', gif: 'bg-purple-50 text-purple-700 border-purple-200',
  mp4: 'bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200', mov: 'bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200',
  webm: 'bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200',
  mp3: 'bg-amber-50 text-amber-800 border-amber-200', wav: 'bg-amber-50 text-amber-800 border-amber-200',
  m4a: 'bg-amber-50 text-amber-800 border-amber-200',
};

export function FileExtensionBadge({ ext }) {
  if (!ext) return null;
  const cls = EXT_PALETTE[ext] || 'bg-slate-50 text-slate-700 border-slate-200';
  return (
    <span
      data-testid={`tf-evidence-ext-badge-${ext}`}
      className={`inline-flex items-center rounded-md border px-1.5 py-0.5 text-xs font-mono font-medium uppercase ${cls}`}
    >
      .{ext}
    </span>
  );
}
